import styled from "styled-components";

// Native button that looks like the surrounding text, for controls that used to be clickable divs.
export const TextButton = styled.button`
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    font: inherit;
    text-align: inherit;
`;
